import api from '@/api'
import PixelRequest from '@/model/campaign/PixelRequest'
import PixelSearchRequest from '@/model/campaign/PixelSearchRequest'
import AffiliateRequest from '@/model/affiliate/AffiliateRequest';

export default {
  namespaced: true,
  state: {
    statusIds: []
  },
  getters: {
    statusIds: state => state.statusIds,
    statusById: state => id => state.statusIds.find(status => status.id === id)
  },
  mutations: {
    updateData(state, data) {
    }
  },
  actions: {
    refreshData({ commit }) {
      return api.base()
        .get('/pixel/data')
        .then(
          response => {
            commit('updateData', response.data.data);
          }
        );
    },
    getAllPixels(actions, {filter,pagination,sort}) {
      return api.base()
        .post('/pixel/get/all',
          PixelSearchRequest( { ...(filter || {}), pagination, sort, })
        )
        .then(response => ({
            data: response.data.data,
            pagination: { page: response.data.metadata.page, total: response.data.metadata.total},
            sort: response.data.metadata.sort
          })
        )
    },
    getPixelById({ commit }, id) {
      return api.base()
        .get('/pixel/id/' + id)
        .then(
          response => {
            return response.data.data
          }
        )
    },

    createPixel({ commit }, { pixel }) {
      return api.base()
        .post('/pixel/add', PixelRequest(pixel))
        .then(
          response => {
            return response.data.data;
          }
        );
    },
    updatePixel({ commit }, { pixel, id }) {
      return api.base()
        .post('/pixel/update/'+id, PixelRequest(pixel))
        .then(
          response => {
            return response.data.data
          }
        )
    }
  },
}
